import { motion, AnimatePresence } from "framer-motion";
import { Eye, Star } from "lucide-react";

export default function SharpEyesCelebration({ count, total, onClose }) {
  return (
    <AnimatePresence>
      {count > 0 && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="fixed inset-0 z-[60] bg-[#0EA5A4]/90 backdrop-blur-sm flex items-center justify-center p-5 overflow-hidden" data-testid="sharp-eyes-celebration">
          {[...Array(12)].map((_, k) => (
            <motion.div key={k} className="absolute" style={{ left: `${(k * 41) % 100}%`, top: "-5%" }}
              initial={{ y: 0, opacity: 0 }} animate={{ y: "110vh", rotate: 360, opacity: [0, 1, 1, 0] }}
              transition={{ duration: 2.8 + (k % 3) * 0.5, delay: k * 0.15, repeat: Infinity }}>
              <Star size={18 + (k % 3) * 8} fill={["#FFC83D", "#FF6B4A", "#3D8BFF"][k % 3]} className="text-transparent" />
            </motion.div>
          ))}
          <motion.div initial={{ scale: 0.6, rotate: 6 }} animate={{ scale: 1, rotate: 0 }} transition={{ type: "spring", stiffness: 260, damping: 14 }}
            className="relative bg-white rounded-[36px] p-8 max-w-sm w-full text-center font-kids shadow-[0_30px_80px_rgba(0,0,0,0.35)]">
            <motion.div animate={{ scale: [1, 1.12, 1] }} transition={{ duration: 1.4, repeat: Infinity }}
              className="w-28 h-28 mx-auto rounded-full flex items-center justify-center bg-[#14B8A6]">
              <Eye color="#fff" size={56} />
            </motion.div>
            <h2 className="text-3xl font-black mt-5 text-slate-900" data-testid="sharp-eyes-title">Sharp Eyes! {total > 1 ? `×${total}` : ""}</h2>
            <p className="font-parent text-slate-600 mt-2">
              You spotted a problem in a question and we fixed it. Thank you for helping! <b>+{20 * count} stars</b>
            </p>
            <p className="font-parent text-slate-500 text-sm mt-1">Yeux de lynx ! Merci de nous avoir aidés.</p>
            <button onClick={onClose} data-testid="sharp-eyes-ok"
              className="mt-6 w-full rounded-full bg-slate-900 text-white font-bold py-3 hover:bg-slate-700 transition-colors">Awesome!</button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
